
import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { koKR as coreKoKR } from '@mui/material/locale';
import { koKR as dataGridKoKR } from '@mui/x-data-grid';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { koKR as pickersKoKR } from '@mui/x-date-pickers/locales';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import koLocale from 'dayjs/locale/ko';

const theme = createTheme(
    {
      typography: {
        fontFamily: "'Pretendard', sans-serif",
        //fontSize:"10px"
      },
      palette: {
        //primary: { main: '#1976d2' },
        mode: 'dark',
      },
      components: {
        MuiButton: {
          defaultProps: {
            size: 'small',
          },
        },
        MuiFilledInput: {
          defaultProps: {
            margin: 'dense',
          },
        },
        MuiFormControl: {
          defaultProps: {
            margin: 'dense',
          },
        },
        MuiFormHelperText: {
          defaultProps: {
            margin: 'dense',
          },
        },
        MuiIconButton: {
          defaultProps: {
            size: 'small',
          },
        },
        MuiInputBase: {
          defaultProps: {
            margin: 'dense',
          },
        },
        MuiInputLabel: {
          defaultProps: {
            margin: 'dense',
          },
        },
        MuiListItem: {
          defaultProps: {
            dense: true,
          },
        },
        MuiOutlinedInput: {
          defaultProps: {
            margin: 'dense',
          },
        },
        MuiFab: {
          defaultProps: {
            size: 'small',
          },
        },
        MuiTable: {
          defaultProps: {
            size: 'small',
          },
        },
        MuiTextField: {
          defaultProps: {
            margin: 'dense',
          },
        },
        MuiToolbar: {
          defaultProps: {
            variant: 'dense',
          },
        },
      },
    },
    pickersKoKR, // x-date-pickers translations
    dataGridKoKR, // x-data-grid translations
    coreKoKR, // core translations
  );

const ThemeModeContext = React.createContext({ 
  toggleColorMode: () => {}, 
  setDarkMode: () => {}, 
  setLightMode: () => {} 
});

export const CommonThemeProvider = (props) => {
    const { children } = props;

    const [mode, setMode] = React.useState('light');
    const colorMode = React.useMemo(
      () => ({
        toggleColorMode: () => {
          setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
        },
        setDarkMode: () => {
          setMode('dark');
        },
        setLightMode: () => {
          setMode('light');
        },
      }),
      [],
    );
  
    const defaultTheme = React.useMemo(
      () =>
        createTheme({
          ...theme,
          palette: {
            mode,
          },
        }),
      [mode],
    );

    return (
        <ThemeModeContext.Provider value={colorMode}>
          <ThemeProvider theme={defaultTheme}>
           <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={koLocale}>
                {children}
            </LocalizationProvider>
          </ThemeProvider>
        </ThemeModeContext.Provider>
      );
}

export const useDarkMode = () => {
  const themeMode = React.useContext(ThemeModeContext);
  React.useEffect(() => {
      themeMode.setDarkMode()
  }, [themeMode]);
}

export const useLightMode = () => {
  const themeMode = React.useContext(ThemeModeContext);
  React.useEffect(() => {
      themeMode.setLightMode()
  }, [themeMode]);
}